import React from 'react'
import { useSelector } from 'react-redux'
import WordSearch from './minigames/WordSearch'
import Quizz from './minigames/Quizz'
import Puzzle from './minigames/Puzzle'

const Minigame = ({ tags }) => {
    const currentNarrative = useSelector(state => state.game.currentNarrativeObject)

    return tags.minigame === 'puzzle' ? <Puzzle img={tags.puzzleImg} narrative={true} /> :
        tags.minigame === 'quizz' ? <Quizz quizz={tags.quizzFile} /> :
            tags.minigame === 'wordSearch' && <WordSearch data={currentNarrative.minigames.wordsearch[`${tags.wordSearchFile}`]} />
}

export default Minigame